import Rete from "rete";
import { NumberSocket } from "../../rete-controls/NumberControl.js";
import { ArraySocket } from "../../../Utils/CommonSockets.js";
import { ResetSocket } from "../../rete-controls/ResetControl.js";
import { EventBus } from '../../../event-bus.js';

export default class NumberArrayCollector extends Rete.Component {
  constructor() {
    super("Number Collector"); // name
    this._categories = ["Simulator"];
    this._myArray = [];
    this._currentIndex = null;
    this._currentConnectedInput = null;
    this._currentIndexWasConnected = false;

    EventBus.$on('global-reset-nodes', x => {
        this.doResetNode();
    });
  }

  builder(node) {
    var inp1 = new Rete.Input("in1", "Number", NumberSocket);
    var inp2 = new Rete.Input("in2", "Index", NumberSocket);
    var inp3 = new Rete.Input("resetIn", "Reset", ResetSocket);

    let out1 = new Rete.Output("out1", "Number Array", ArraySocket);

    return node
      .addInput(inp1)
      .addInput(inp2)
      .addInput(inp3)
      .addOutput(out1);
  }

  doResetNode() {
    this._myArray = [];
    this._currentIndex = null;
    // this._currentConnectedInput = null;
    // this._currentIndexWasConnected = false;
  }
  resetNode(in3, node) {
    if (node.inputs["resetIn"].connections[0] != null)
      if (in3 !== null && in3 !== undefined) this.doResetNode();
  }
  worker(node, inputs, outputs) {
    this.resetNode(inputs["resetIn"][0], node);
    let in1 = inputs["in1"][0];
    let in2 = inputs["in2"][0];
    let doAdd = false;

    let newConnection = node.inputs["in1"].connections[0];
    let indexConnection = node.inputs["in2"].connections[0];
    if (in1 !== [] && in1 !== undefined) {
      if (this._currentConnectedInput != null) {
        if (
          newConnection.node !== this._currentConnectedInput.node ||
          newConnection.output !== this._currentConnectedInput.output
        ) {
          this._currentConnectedInput = newConnection;
          this._myArray.length = 0;
          this._currentIndex = null;
        }
      } else {
        this._currentConnectedInput = newConnection;
        this._myArray.length = 0;
        this._currentIndex = null;
      }

      in1 = +in1;
      doAdd = true;

      if (in2 != [] && in2 !== undefined) {
        in2 = +in2;
        if (this._currentIndex !== in2) {
          this._currentIndex = in2;
        } else {
          doAdd = false;
        }
        if (this._currentIndexWasConnected == false) {
          doAdd = false;
          this._currentIndexWasConnected = true;
        }
      } else if (this._currentIndexWasConnected) {
        this._currentIndexWasConnected = false;
        doAdd = false;
      }
    } else {
      if (newConnection == null) {
        this._currentConnectedInput = null;
        this._myArray.length = 0;
        this._currentIndex = null;
      }
      if (indexConnection != null) {
        this._currentIndexWasConnected = true;
      } else {
        this._currentIndexWasConnected = false;
      }
    }
    if (doAdd) this._myArray.push(in1);
    outputs["out1"] = this._myArray;
  }
}
